<mat-chip-listbox aria-label="status" class="log-status">
    <mat-chip-option *ngIf="this.status == 1" class="processing" selected>Processando</mat-chip-option>
    <mat-chip-option *ngIf="this.status == 2" class="success" selected>Sucesso</mat-chip-option>
    <mat-chip-option *ngIf="this.status == 3" class="warning" selected>Alerta</mat-chip-option>
    <mat-chip-option *ngIf="this.status == 4" class="error" selected>Erro</mat-chip-option>
</mat-chip-listbox>